/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_bookmark__delete_favorite_arialabel1 = /** @type {(inputs: {}) => string} */ () => {
	return `Route löschen`
};

const en_bookmark__delete_favorite_arialabel1 = /** @type {(inputs: {}) => string} */ () => {
	return `Delete route`
};

const es_bookmark__delete_favorite_arialabel1 = /** @type {(inputs: {}) => string} */ () => {
	return `Eliminar ruta`
};

const fr_bookmark__delete_favorite_arialabel1 = /** @type {(inputs: {}) => string} */ () => {
	return `Effacer l'itinéraire`
};

const it_bookmark__delete_favorite_arialabel1 = /** @type {(inputs: {}) => string} */ () => {
	return `Vai all'itinerario`
};

const nl_bookmark__delete_favorite_arialabel1 = /** @type {(inputs: {}) => string} */ () => {
	return `Route verwijderen`
};

const pt_bookmark__delete_favorite_arialabel1 = /** @type {(inputs: {}) => string} */ () => {
	return `Eliminar a rota`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const bookmark__delete_favorite_arialabel1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bookmark__delete_favorite_arialabel1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("bookmark__delete_favorite_arialabel1", locale)
	if (locale === "de") return de_bookmark__delete_favorite_arialabel1(inputs)
	if (locale === "en") return en_bookmark__delete_favorite_arialabel1(inputs)
	if (locale === "es") return es_bookmark__delete_favorite_arialabel1(inputs)
	if (locale === "fr") return fr_bookmark__delete_favorite_arialabel1(inputs)
	if (locale === "it") return it_bookmark__delete_favorite_arialabel1(inputs)
	if (locale === "nl") return nl_bookmark__delete_favorite_arialabel1(inputs)
	return pt_bookmark__delete_favorite_arialabel1(inputs)
};
export { bookmark__delete_favorite_arialabel1 as "bookmark__delete_favorite_ariaLabel" }